/* istanbul ignore file */
import { createAction } from '@reduxjs/toolkit';
import { UtmTags } from 'core/user/entities';

export const userUtmTagsUpdated = createAction<UtmTags>('userUtmTags/UPDATED');
